import { useEffect } from "react";
import { IDataFormEstimate, TModeEstimate } from "../../../..";
import { ISelectItem, TSelectValue } from "../../../../../../ui/select";
import { ISelectItemExpended } from "../../../../interfaces";

const useSetDataForm = (
  dataForm: IDataFormEstimate | undefined,
  selectedStreetOrComplex: number | null,
  streets: ISelectItem[],
  selectedBuilding: number | null,
  buildings: ISelectItemExpended[],
  areaInSqM: string | null | undefined,
  apartmentNumber: number | null,
  isLoadingStreets: boolean,
  isLoadingBuildings: boolean,
  facilityTypeId: number | null,
  mode: TModeEstimate,
  onSelectStreetsOrComplex: (value: TSelectValue) => void,
  onSelectBuilding: (value: TSelectValue) => void,
  handleChangeTypeApartment: (type: number) => void,
  handleChangeApartmentArea: (data: string) => void,
  handleChangeApartmentNumber: (data: string) => void,
  handleIsReset: (value: boolean) => void
) => {
  useEffect(() => {
    if (!selectedStreetOrComplex && dataForm?.streetId) {
      handleIsReset(true);
      onSelectStreetsOrComplex(dataForm.streetId);
    }
  }, [dataForm?.streetId]);

  useEffect(() => {
    if (
      streets.length &&
      !isLoadingStreets &&
      !selectedBuilding &&
      dataForm?.buildingId
    ) {
      onSelectBuilding(dataForm.buildingId);
    }
  }, [dataForm?.buildingId, streets.length]);

  useEffect(() => {
    if (
      buildings.length &&
      !isLoadingBuildings &&
      !areaInSqM &&
      dataForm?.areaInSqM
    ) {
      handleChangeApartmentArea(String(dataForm.areaInSqM));
      //включим чтобы сбрасывались по услоивю описаному в хуке ресета
      handleIsReset(false);
    }
  }, [dataForm?.areaInSqM, buildings.length]);

  useEffect(() => {
    if (!facilityTypeId && dataForm?.facilityTypeId && mode === "dealService") {
      handleChangeTypeApartment(dataForm.facilityTypeId);
    }
  }, [dataForm?.facilityTypeId]);

  useEffect(() => {
    if (!apartmentNumber && dataForm?.apartmentNumber && mode === "quiz") {
      handleChangeApartmentNumber(String(dataForm.apartmentNumber));
    }
  }, [dataForm?.apartmentNumber]);

  return {};
};

export default useSetDataForm;
